function toutou_xy_precip_type(myJson, zoom, ctx) {
    //Argument optionel
    if (zoom != null) var my_zoom = zoom;
    else var my_zoom = 0;
    // Donnees de MySQL
    var ni = myJson.hhh.length;
    var apcpn_tot = new Array(ni);
    var apcpn_rn = new Array(ni);
    var apcpn_fr = new Array(ni);
    var apcpn_pe = new Array(ni);
    var apcpn_sn = new Array(ni);
    var hhh = new Array(ni);
    var time_label = new Array(ni);
    var aaaammjj = myJson.aaaammjj;
    var hh = myJson.hh;
    var my_fonts = new Toutou_Fonts();
    var tr = new Toutou_Transform();
    var datev = dateo;
    var im = 0;
    // Note : a cause de la compaction, le precip accumulee peut reduire avec le temps. Les max
    //        ci-dessous sont la pour empecher cela.
    apcpn_rn[0] = 0.;
    apcpn_fr[0] = 0.;
    apcpn_pe[0] = 0.;
    apcpn_sn[0] = 0.;
    for(var i = 0; i < ni; i++){
        im = Math.max(0, i - 1);
        apcpn_rn[i] = Math.max(apcpn_rn[im], myJson.data1[i] * .01);
        apcpn_fr[i] = Math.max(apcpn_fr[im], myJson.data2[i] * .01);
        apcpn_pe[i] = Math.max(apcpn_pe[im], myJson.data3[i] * .01);
        apcpn_sn[i] = Math.max(apcpn_sn[im], myJson.data4[i] * .01);
        apcpn_tot[i] = apcpn_rn[i] + apcpn_fr[i] + apcpn_pe[i] + apcpn_sn[i];
        hhh[i] = myJson.hhh[i];
    }
    // POur faire teste info hover
    //i=1
    //apcpn_rn[i]=1
    //apcpn_fr[i]=2
    //apcpn_pe[i]=3
    //apcpn_sn[i]=4
    apcpn_tot[i] = apcpn_rn[i] + apcpn_fr[i] + apcpn_pe[i] + apcpn_sn[i];
    pointsData['precip_type'] = [];
    // Espace autour de la boite du graphique en %
    var pil_w = .08;
    var pil_e = .01;
    var pil_s = .2;
    var pil_n = .25;
    if (ctx == undefined) ctx = set_canvas('toutou_xy_precip_type');
    tr.xrange(my_zoom, hhh);
    tr.ymin = apcpn_tot.min();
    tr.ymax = apcpn_tot.max();
    dimx = tr.xmax - tr.xmin;
    tr.xmin = tr.xmin - .02 * dimx;
    tr.xmax = tr.xmax + .02 * dimx;
    dimy = tr.ymax - tr.ymin;
    tr.ymax = tr.ymax + .02 * gxsize / gysize * dimy;
    tr.ymax = Math.max(tr.ymax, 1.);
    incy = 1;
    nj = Math.floor(tr.ymax) - Math.ceil(tr.ymin) + 1;
    if (nj > 12) incy = 2;
    if (nj > 24) incy = 5;
    if (nj > 100) incy = 10;
    tr.ymax = Math.floor(tr.ymax);
    tr.ymax = tr.ymax + (incy - tr.ymax % incy);
    tr.ymin = Math.ceil(tr.ymin);
    tr.ymin = tr.ymin - (tr.ymin % incy + incy);
    tr.ymin = Math.max(0., tr.ymin - Math.abs(tr.ymin % incy));
    nj = Math.floor(tr.ymax) - Math.ceil(tr.ymin) + 1;
    tr.pix_margeg = Math.round(pil_w * gxsize) + .5;
    tr.pix_marged = Math.round((1. - pil_e) * gxsize) + .5;
    tr.pix_margeh = Math.round(pil_n * gysize) + .5;
    tr.pix_margeb = Math.round((1. - pil_s) * gysize) + .5;
    tr.init(my_zoom);
    pointsData['precip_type_params'] = {
        xmin_pix: tr.d2px(tr.xmin),
        xmax_pix: tr.d2px(tr.xmax),
        ymin_pix: tr.d2py(tr.ymin),
        ymax_pix: tr.d2py(tr.ymax),
        pr_col: 'black',
        rn_col: 'green',
        fr_col: 'red',
        pe_col: 'magenta',
        sn_col: 'blue'
    };
    tr.xmin_pix = tr.d2px(tr.xmin);
    tr.xmax_pix = tr.d2px(tr.xmax);
    tr.ymin_pix = tr.d2py(tr.ymin);
    tr.ymax_pix = tr.d2py(tr.ymax);
    ctx.fillStyle = '#FFF';
    ctx.fillRect(0, 0, gxsize, gysize);
    tr.draw_model_zones(ctx, my_fonts, hhh, myJson.modele);
    // Titre principal
    ctx.font = my_fonts.principal;
    ctx.fillStyle = "#33A";
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText("Date de d\xe9part : " + toutou_xy_titre_principal(dateo), .5 * (tr.xmax_pix + tr.xmin_pix), 0);
    ctx.restore();
    // Titre secondaire
    ctx.font = my_fonts.legende;
    ctx.fillStyle = "black";
    ctx.textAlign = "left";
    ctx.textBaseline = "bottom";
    ctx.fillText('Courbe noire   : accumulation totale de precipitation [mm]', tr.xmin_pix, tr.ymax_pix * .4);
    ctx.fillStyle = "green";
    ctx.fillStyle = "green";
    ctx.fillText('Courbe verte   : accumulation de pluie   [mm]', tr.xmin_pix, tr.ymax_pix * .55);
    ctx.fillStyle = "blue";
    ctx.fillStyle = "blue";
    ctx.fillText('Courbe bleu    : accumulation de neige en equivalent eau [mm]', tr.xmin_pix, tr.ymax_pix * .7);
    ctx.fillStyle = "red";
    ctx.fillStyle = "red";
    ctx.fillText('Courbe rouge   : accumulation de verglas [mm]', tr.xmin_pix, tr.ymax_pix * .85);
    ctx.fillStyle = "magenta";
    ctx.fillStyle = "magenta";
    ctx.fillText('Courbe magenta : accumulation de gresil en equivalent eau [mm]', tr.xmin_pix, tr.ymax_pix * 1.);
    // xticks
    tr.xticks_jours(datev, hhh, ctx, my_fonts, my_zoom, {
        time_label
    });
    // yticks
    ctx.beginPath();
    ctx.font = my_fonts.axis;
    ctx.fillStyle = "Black";
    nj = Math.floor(tr.ymax) - Math.ceil(tr.ymin) + 1;
    ctx.strokeStyle = 'black';
    ctx.textAlign = "right";
    ctx.textBaseline = "middle";
    xx = Math.round(tr.xmin_pix - .01 * (tr.xmax_pix - tr.xmin_pix)) + .5;
    for(var i = 0; i < nj; i = i + incy){
        yy = Math.round(tr.d2py(Math.ceil(tr.ymin) + i)) + .5;
        ctx.moveTo(tr.xmin_pix, yy);
        ctx.lineTo(xx, yy);
        ctx.fillText(Math.ceil(tr.ymin) + i + ' ', xx, yy);
    }
    ctx.stroke();
    // Lignes grises
    for(var i = 0; i < nj; i = i + incy){
        val = Math.ceil(tr.ymin) + i;
        yy = Math.round(tr.d2py(val)) + .5;
        ctx.beginPath();
        ctx.strokeStyle = '#bbb';
        // Ligne verte 30
        if (val == 30 | val == 50) ctx.strokeStyle = 'green';
        if (val == 100) ctx.strokeStyle = 'red';
        ctx.moveTo(tr.xmin_pix, yy);
        ctx.lineTo(tr.xmax_pix, yy);
        ctx.stroke();
    }
    // Tracer tot
    ctx.beginPath();
    ctx.fillStyle = pointsData['precip_type_params'].pr_col;
    ctx.strokeStyle = pointsData['precip_type_params'].pr_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]), tr.d2py(apcpn_tot[tr.xind_min]));
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(apcpn_tot[i]);
        ctx.lineTo(xx, yy);
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        if (apcpn_tot[i] > 0.) pointsData['precip_type'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            pr: apcpn_tot[i],
            fr: apcpn_fr[i],
            pe: apcpn_pe[i],
            sn: apcpn_sn[i],
            rn: apcpn_rn[i]
        });
    }
    ctx.stroke();
    // Tracer rn
    ctx.beginPath();
    ctx.fillStyle = pointsData['precip_type_params'].rn_col;
    ctx.strokeStyle = pointsData['precip_type_params'].rn_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]), tr.d2py(apcpn_rn[tr.xind_min]));
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(apcpn_rn[i]);
        ctx.lineTo(xx, yy);
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        pointsData['precip_type'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            pr: apcpn_tot[i],
            fr: apcpn_fr[i],
            pe: apcpn_pe[i],
            sn: apcpn_sn[i],
            rn: apcpn_rn[i]
        });
        if (apcpn_rn[i] > 0.) pointsData['precip_type'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            pr: apcpn_tot[i],
            fr: apcpn_fr[i],
            pe: apcpn_pe[i],
            sn: apcpn_sn[i],
            rn: apcpn_rn[i]
        });
    }
    ctx.stroke();
    // Tracer fr
    ctx.beginPath();
    ctx.fillStyle = pointsData['precip_type_params'].fr_col;
    ctx.strokeStyle = pointsData['precip_type_params'].fr_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]), tr.d2py(apcpn_fr[tr.xind_min]));
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(apcpn_fr[i]);
        ctx.lineTo(xx, yy);
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        if (apcpn_fr[i] > 0.) pointsData['precip_type'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            pr: apcpn_tot[i],
            fr: apcpn_fr[i],
            pe: apcpn_pe[i],
            sn: apcpn_sn[i],
            rn: apcpn_rn[i]
        });
    }
    ctx.stroke();
    // Tracer pe
    ctx.beginPath();
    ctx.fillStyle = pointsData['precip_type_params'].pe_col;
    ctx.strokeStyle = pointsData['precip_type_params'].pe_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]), tr.d2py(apcpn_pe[tr.xind_min]));
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(apcpn_pe[i]);
        ctx.lineTo(xx, yy);
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        if (apcpn_pe[i] > 0.) pointsData['precip_type'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            pr: apcpn_tot[i],
            fr: apcpn_fr[i],
            pe: apcpn_pe[i],
            sn: apcpn_sn[i],
            rn: apcpn_rn[i]
        });
    }
    ctx.stroke();
    // Tracer sn
    ctx.beginPath();
    ctx.fillStyle = pointsData['precip_type_params'].sn_col;
    ctx.strokeStyle = pointsData['precip_type_params'].sn_col;
    ctx.moveTo(tr.d2px(hhh[tr.xind_min]), tr.d2py(apcpn_sn[tr.xind_min]));
    for(var i = tr.xind_min; i <= tr.xind_max; i++){
        xx = tr.d2px(hhh[i]);
        yy = tr.d2py(apcpn_sn[i]);
        ctx.lineTo(xx, yy);
        ctx.fillRect(xx - tr.dd, yy - tr.dd, 2 * tr.dd, 2 * tr.dd);
        if (apcpn_sn[i] > 0.) pointsData['precip_type'].push({
            x: xx,
            y: yy,
            tl: time_label[i],
            pr: apcpn_tot[i],
            fr: apcpn_fr[i],
            pe: apcpn_pe[i],
            sn: apcpn_sn[i],
            rn: apcpn_rn[i]
        });
    }
    ctx.stroke();
}

//# sourceMappingURL=imeteo.f17ac77c.js.map
